import CustomPriorityCallbackType from '../store/schema/CustomPriorityCallbackType';
import getCalendarEventByKey from './getCalendarEventByKey';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';
import { getStoreConfig } from '../store/store';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';

function customCompare(eventKey1: CalendarEventKey, eventKey2: CalendarEventKey): number {
    let value = 0;
    const event1: CalendarEvent = getCalendarEventByKey(eventKey1);
    const event2: CalendarEvent = getCalendarEventByKey(eventKey2);
    const dummyEventFiltered = dummyEventFilter(event1, event2);

    if (!isNullOrUndefined(dummyEventFiltered)) {
        return dummyEventFiltered;
    }

    // custom callbacks seem to return a different order where higher priority value suggests a lower position in sorting.
    // lower position means coming early in the list with a lower index.
    const customCallbacks: CustomPriorityCallbackType[] = getStoreConfig().customPriorityCallbacks;
    for (let i = 0; i < customCallbacks.length; i++) {
        if (customCallbacks[i](event1) > customCallbacks[i](event2)) {
            value = -1;
            break;
        } else if (customCallbacks[i](event1) < customCallbacks[i](event2)) {
            value = 1;
            break;
        }
    }
    return value;
}

function dummyEventFilter(event1: CalendarEvent, event2: CalendarEvent): number | null {
    /**
     * This check is given for the dummy event which was created to compare. Dummy event will always be lesser than the other.
     */
    if (event1 && !event1.ItemId && event2 && !event2.ItemId) {
        return 0;
    }

    if (event1 && !event1.ItemId) {
        return -1;
    }

    if (event2 && !event2.ItemId) {
        return 1;
    }
    return null;
}

function timestampBasedPriority(eventKey: CalendarEventKey) {
    return eventKey.timestamp;
}

function fallbackPriority(eventKey: CalendarEventKey) {
    return eventKey.itemId;
}

/**
 * Method that compares two calendar event/key, start with the base comparer -> custom comparer -> fallback comparer.
 * @param eventKey1 - key of event1
 * @param eventKey2 - key of event2
 * @returns returns the value indicating the sort order. 0 - both equal, 1 - event1 is greater, -1 - event2 is greater.
 */
export function eventComparer(eventKey1: CalendarEventKey, eventKey2: CalendarEventKey): number {
    if (!eventKey1 && !eventKey2) {
        return 0;
    } else if (!eventKey1 && eventKey2) {
        return -1;
    } else if (eventKey1 && !eventKey2) {
        return 1;
    }
    return timestampBasedPriority(eventKey1) > timestampBasedPriority(eventKey2)
        ? 1
        : timestampBasedPriority(eventKey1) < timestampBasedPriority(eventKey2)
        ? -1
        : customCompare(eventKey1, eventKey2) !== 0
        ? customCompare(eventKey1, eventKey2)
        : fallbackPriority(eventKey1) > fallbackPriority(eventKey2)
        ? 1
        : fallbackPriority(eventKey1) < fallbackPriority(eventKey2)
        ? -1
        : 0;
}
